import configMixin from "@/mixin/config";
import Header from "@/components/Header";
import { common } from "@/model/common";
import authService from "@/services/authService";
import { interact } from "fire-wind-water";
import Banner from "@/components/Banner";

export default {
  name: "login-success",
  components: {
    Header,
    Banner,
  },
  mixins: [configMixin],
  data: function () {
    return {
      name: "",
      avatar: require("@/assets/images/head-default.jpg"),
      personalCenterUrl:
        "//" +
        window.location.hostname +
        "/usercenter/" +
        "index.html?tenantId=" +
        common.tenantid +
        "&schemaId=" +
        common.memberSchemaId +
        "&memberFormId=" +
        common.memberFormId,
      userInfo: null,
      memberSchemaId: common.memberSchemaId,
      memberFormId: common.memberFormId,
      tenantid: "",
      token: common.token,
    };
  },
  methods: {
    init() {
      let self = this;
      self.userInfo = common.getSession();
      if (this.isSetting) return;
      common.backUrl = "";
      if (!self.userInfo || !self.userInfo.session) {
        return common.routerPush(self, "login", { token: this.token });
      }
      authService
        .getForm({
          memberFormId: common.memberFormId,
          schemaId: common.memberSchemaId,
        })
        .then((data) => {
          let formInfo = data.content;
          self.tenantid = formInfo.tenantId;
          common.handPage(formInfo);
          window.$sk.template.update({
            type: "link",
            data: {
              identity: 1,
              weChatId: formInfo.authWeChatId || 0,
              skObjectType: "member",
              skObjectId: self.memberFormId,
              meetingInstanceId: "",
              meetingType: "",
              skIsNotLink: "",
              memberFormId: "",
            },
          });
        });
    },
    logout() {
      authService
        .logout({
          url: window.location.href,
          browseInfo: interact.browseInfo,
          memberFormId: this.memberFormId,
          schemaId: this.memberSchemaId,
          sess: this.userInfo.session,
          type: 2,
        })
        .then(() => {
          common.removeSession();
          common.removeTokenPush("login");
        });
    },
    skUserEnd() {
      let json = window.$sk.template.get();
      common.register(json);
      this.initConfig();
      this.init();
    },
    skLinkEnd() {
      let self = this;
      let params = {
        tenantId: self.tenantid,
        schemaId: self.memberSchemaId,
        sess: self.userInfo && self.userInfo.session,
        isTemplate: 1,
      };
      authService.getMyInfo(params).then((res) => {
        if (res.result == 3) {
          common.removeSession();
          common.removeTokenPush("login");
        }
        if (res.result != 0) return;
        self.personalCenterUrl = window.$sk.replaceDomain(
          window.$sk.config.usercenterUrl +
            "index.html?tenantId=" +
            self.tenantid +
            "&schemaId=" +
            self.memberSchemaId +
            "&memberFormId=" +
            self.memberFormId
        );
        window.$sk.loading.hide();
        if (res.content["headImgUrl"]) self.avatar = res.content["headImgUrl"];
        self.name = res.content["name"] ? res.content["name"] : "";
      });
    },
  },
  created() {
    window.$sk.loading.show();
    if (this.isSetting) {
      this.initConfig();
      window.$sk.loading.hide();
      return;
    }
    this.sk = window.$sk.template.module(this);
  },
  beforeDestroy() {
    this.sk.unsubscribe();
  },
};
